import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

type Props = { API: string; onChange?: () => void };
const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const errOf = (e: any, d: string) => (e && e.response && e.response.data && e.response.data.detail) || d;
const inp: any = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
const btn: any = { padding: '7px 14px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 13, cursor: 'pointer' };
const btnP: any = { ...btn, border: '1px solid #1d4ed8', background: '#1d4ed8', color: '#fff', fontWeight: 600 };

export default function PakowalniaSettings({ API, onChange }: Props) {
  const [st, setSt] = useState<any>(null);
  const [tok, setTok] = useState('');
  const [msg, setMsg] = useState<any>(null);
  const load = () => { axios.get(API + '/settings/pakowalnia', { headers: auth() }).then((r: any) => setSt(r.data)).catch(() => setSt(null)); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [API]);
  const save = () => {
    setMsg({ ok: null, text: '⏳ Zapisywanie…' });
    axios.post(API + '/settings/pakowalnia', { token: tok }, { headers: auth() })
      .then((r: any) => { setSt(r.data); setTok(''); setMsg({ ok: true, text: '✓ Zapisano token.' }); if (onChange) onChange(); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zapisać.') }));
  };
  const del = () => {
    if (!window.confirm('Usunąć token przycisku paragonu? Przycisk „Paragon” przestanie działać.')) return;
    axios.delete(API + '/settings/pakowalnia', { headers: auth() })
      .then((r: any) => { setSt(r.data); setMsg({ ok: true, text: '✓ Usunięto token.' }); if (onChange) onChange(); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się usunąć.') }));
  };
  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, maxWidth: 640 }}>
      <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Pakowalnia (noboco)</div>
      <div style={{ fontSize: 13, color: '#374151', marginBottom: 12 }}>
        Przycisk „🧾 Paragon” w zamówieniu wysyła z serwera OPENkontakt zlecenie do Pakowalni — Pakowalnia wystawia paragon w kasie,
        drukuje go i sama podpina pod zamówienie. Jeden paragon na zamówienie.
      </div>
      <label style={{ fontSize: 12, color: '#374151', marginBottom: 4, display: 'block', fontWeight: 600 }}>
        Token przycisku paragonu {st && st.configured ? <span style={{ fontWeight: 400, color: '#15803d' }}>(zapisany — wpisz nowy, aby zmienić)</span> : null}
      </label>
      <input type="password" value={tok} onChange={(e: any) => setTok(e.target.value)} autoComplete="new-password"
        placeholder={st && st.configured ? '••••••••' : 'z Ustawień Pakowalni, pole „Token przycisku paragonu”'} style={{ ...inp, marginBottom: 10 }} />
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <button onClick={save} disabled={!tok.trim()} style={{ ...btnP, opacity: tok.trim() ? 1 : 0.5 }}>Zapisz token</button>
        {st && st.configured ? <button onClick={del} style={{ ...btn, color: '#b91c1c', borderColor: '#fecdd3' }}>Usuń</button> : null}
        {msg ? <span style={{ fontSize: 13, fontWeight: 600, color: msg.ok === true ? '#15803d' : (msg.ok === false ? '#b91c1c' : '#6b7280') }}>{msg.text}</span> : null}
      </div>
    </div>
  );
}
